import { l } from 'client/Other/Translation'
import React from 'react'

import './InputGroupHeader.scss'

interface IInputGroupHeaderProps {
  title: string
  children?: null | React.ReactElement
}

const InputGroupHeader: React.FC<IInputGroupHeaderProps> = ({ title, children = null }) => {
  return title === l('settings.paymentMethod.IBAN') ? (
    <div className={'groupHeaderIban'}>
      {title} {children}
    </div>
  ) : (
    <div className={'groupHeader'}>
      {title} {children}
    </div>
  )
}

export default InputGroupHeader
